import * as React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { CdnIcon } from '@shared/ui';
import { isRequestedService, isUnconfirmedService } from '../../../utils';
import ServiceSummaryGroup from '../ServiceSummaryGroup/ServiceSummaryGroup';
import ServiceSummaryNotification from '../ServiceSummaryNotification/ServiceSummaryNotification';
const ServiceSummaryOption = ({ groupOption, mode = 'default', serviceType }) => {
    const { t } = useTranslation('Cart');
    const { ServiceSummaryOption: css } = useTheme('ServiceSummary');
    const { items, direction, allSegments, header, subheader, description } = groupOption;
    const services = [];
    const unconfirmedServices = [];
    const requestedServices = [];
    let isLoading = false;
    items.forEach(item => {
        const status = item.status;
        if (isUnconfirmedService(status)) {
            unconfirmedServices.push(item);
        }
        else if (isRequestedService(status)) {
            requestedServices.push(item);
        }
        else {
            services.push(item);
        }
        if (item.isLoading && !isLoading) {
            isLoading = true;
        }
    });
    const hasServices = services.length > 0;
    const hasUnconfirmedServices = unconfirmedServices.length > 0;
    const hasRequestedServices = requestedServices.length > 0;
    const segmentTitle = useMemo(() => {
        if (allSegments) {
            return t('All flights');
        }
        else if (direction) {
            return `${direction.departure.airport.iata} - ${direction.arrival.airport.iata}`;
        }
        return '';
    }, [allSegments, direction]);
    return (React.createElement("div", { className: cn(css.wrapper, {
            [css.unconfirmedServices]: hasUnconfirmedServices,
            [css.loading]: isLoading
        }), "data-description": description || '' },
        header && (React.createElement("div", { className: css.header },
            React.createElement("span", { className: css.header__title }, header),
            segmentTitle && React.createElement("span", { className: css.header__direction }, segmentTitle),
            hasUnconfirmedServices && (React.createElement("div", { className: css.header__icon },
                React.createElement(CdnIcon, { icon: "Info/Warning" }))))),
        subheader && React.createElement("div", { className: css.subheader }, subheader),
        hasServices && React.createElement(ServiceSummaryGroup, { mode: mode, services: services, serviceType: serviceType }),
        hasUnconfirmedServices && (React.createElement(ServiceSummaryGroup, { services: unconfirmedServices, serviceType: serviceType, notification: React.createElement(ServiceSummaryNotification, { status: "unconfirmed" }) })),
        hasRequestedServices && (React.createElement(ServiceSummaryGroup, { services: requestedServices, serviceType: serviceType, notification: React.createElement(ServiceSummaryNotification, { status: "requested" }) }))));
};
export default ServiceSummaryOption;
